import { styled, TableContainer } from '@material-ui/core'

export const StyledTableContainer = styled(TableContainer)(() => ({
  '.MuiTableCell-body': {
    vericalAlign: 'top',
  },
}))
